export enum TypeTeamCodeEnum {
  'SOL' = 'SOL',
  'DUO' = 'DUO',
  'TRI' = 'TRI',
  'QUA' = 'QUA',
  'SQU' = 'SQU',
  'FIV' = 'FIV',
}
